import {
	statusLabel,
	dockTypeLabel,
	formatDate,
	formatTime,
} from '../utils/input-dock-schedule-labels.js';

function esc(s)
{
	return String(s ?? '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

function statusBadge(status)
{
	const label = statusLabel(status);
	const cls = {
		SCHEDULED: 'ids-st-scheduled',
		IN_RECEIVING: 'ids-st-receiving',
		COMPLETED: 'ids-st-completed',
		CANCELLED: 'ids-st-cancelled',
		NO_SHOW: 'ids-st-noshow',
	}[status] || 'ids-st-other';
	return `<span class="ids-badge ${cls}">${esc(label)}</span>`;
}

export default async function (records)
{
	return `
		<style>
			.view th:nth-child(1) { width: 1rem; }
			.view .ids-badge {
				display: inline-block;
				padding: 0.12rem 0.5rem;
				border-radius: 0.3rem;
				font-size: 0.78rem;
				font-weight: 600;
				white-space: nowrap;
			}
			.view .ids-st-scheduled { background: #dbeafe; color: #1e3a8a; }
			.view .ids-st-receiving { background: #ede9fe; color: #5b21b6; }
			.view .ids-st-completed { background: #d1fae5; color: #065f46; }
			.view .ids-st-cancelled { background: #e5e7eb; color: #4b5563; }
			.view .ids-st-noshow { background: #fee2e2; color: #991b1b; }
			.view .ids-st-other { background: #f3f4f6; color: #374151; }
			.view .ids-type { background: #e0e7ff; color: #3730a3; }
			.view .ids-occ { background: #fef3c7; color: #92400e; }
			.view .ids-time { font-variant-numeric: tabular-nums; white-space: nowrap; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Selecionar/desselecionar todos"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Data</th>
					<th data-index="2" data-visible="${this.visible[1]}">Horário</th>
					<th data-index="3" data-visible="${this.visible[2]}">Doca</th>
					<th data-index="4" data-visible="${this.visible[3]}">Tipo</th>
					<th data-index="5" data-visible="${this.visible[4]}">Armazém</th>
					<th data-index="6" data-visible="${this.visible[5]}">Pedido Entrada</th>
					<th data-index="7" data-visible="${this.visible[6]}">NF</th>
					<th data-index="8" data-visible="${this.visible[7]}">Volumes</th>
					<th data-index="9" data-visible="${this.visible[8]}">Fornecedor</th>
					<th data-index="10" data-visible="${this.visible[9]}">Responsável</th>
					<th data-index="11" data-visible="${this.visible[10]}">Status</th>
					<th data-index="12" data-visible="${this.visible[11]}">Ocorrência</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async (record) =>
			{
				const start = record.scheduled_start;
				const end = record.scheduled_end;
				const timeRange = `${formatTime(start)}–${formatTime(end)}`;
				const dockName = record.dock_name
					|| await this.key('input_docks', [record.company_id, record.dock_id], 'name')
					|| record.dock_id
					|| '—';
				const typeLabel = record.dock_type_label
					|| dockTypeLabel(record.dock_type)
					|| '—';
				const occ = record.has_occurrence
					? '<span class="ids-badge ids-occ">Com ocorrência</span>'
					: '—';
				const nf = record.invoice_number ?? '';
				return `<tr data-id='${JSON.stringify([record.company_id, record.id])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([record.company_id, record.id]))}></td>
					<td data-visible='${this.visible[0]}' class="ids-time">${esc(formatDate(start))}</td>
					<td data-visible='${this.visible[1]}' class="ids-time">${esc(timeRange)}</td>
					<td data-visible='${this.visible[2]}'>${esc(dockName)}</td>
					<td data-visible='${this.visible[3]}'><span class="ids-badge ids-type">${esc(typeLabel)}</span></td>
					<td data-visible='${this.visible[4]}'>${await this.key('warehouses', [record.company_id, record.warehouse_id], 'name')}</td>
					<td data-visible='${this.visible[5]}'>${esc(record.input_order_id ?? '—')}</td>
					<td data-visible='${this.visible[6]}'>${esc(nf || '—')}</td>
					<td data-visible='${this.visible[7]}'>${esc(record.volumes ?? '—')}</td>
					<td data-visible='${this.visible[8]}'>${record.supplier_id != null
						? await this.key('suppliers', [record.company_id, record.supplier_id], 'nick')
						: '—'}</td>
					<td data-visible='${this.visible[9]}'>${record.responsible_user_id
						? await this.key('users', record.responsible_user_id, 'name')
						: '—'}</td>
					<td data-visible='${this.visible[10]}'>${statusBadge(record.status)}</td>
					<td data-visible='${this.visible[11]}'>${occ}</td>
				</tr>`;
			}))).join('') + `
			</tbody>
		</table>
	`;
}
